import classNames from 'classnames';
import moment from 'moment-timezone';
import { HTMLAttributes } from 'react';

import TyCalDayHead from './TyCalDayHead';

interface TyCalDayOfWeekProps extends HTMLAttributes<HTMLDivElement> {
  date: string;
  day: number;
}

const TyCalDayOfWeek = ({ date, ...rest }: TyCalDayOfWeekProps) => {
  const m = moment(date);
  const now = moment();
  const day = m.get('date');
  const dayName = m.format('dddd');
  const isToday = m.isSame(now, 'day');

  return (
    <TyCalDayHead
      className={classNames(
        {
          'text-secondary-900': isToday,
          'text-secondary-400': !isToday,
          'bg-secondary-50': [0, 6].includes(m.get('day')),
        },
        'flex flex-col justify-center',
      )}
      {...rest}
    >
      <div className="flex h-[24px] gap-2 items-center font-medium text-sm font-body capitalize">
        {dayName} {isToday && <span className="h-2 w-2 rounded-full bg-secondary-900"></span>}
      </div>
      <div className='flex items-center gap-2'>
        <span className={classNames('font-semibold text-lg')}>
          {day}
        </span>
      </div>
    </TyCalDayHead>
  );
};

export default TyCalDayOfWeek;
